import React from 'react';
import Hero from './components/IQAC/facilities/Hero';
import Main from './components/IQAC/facilities/Main';

const IqacFacilities = () => {
    return (
        <div>
            <Hero />
            <Main />
        </div>
    )
}

export default IqacFacilities;